import React from "react"
import { string, shape } from "prop-types"
import styled from "@emotion/styled"
import CardImage from "../atoms/product-image"
import Heading3 from "../atoms/heading-3"
import CardContentDescription from "../atoms/product-description"

const propTypes = {
  title: string.isRequired,
  fluid: shape(),
  fallbackFluid: shape(),
  body: shape(),
}

const defaultProps = {
  fluid: null,
  fallbackFluid: null,
  body: null,
}

const CardContentWrapper = styled.div`
  margin-bottom: 1.5vw;
`
const Content = styled.div`
  padding: 1em 0;
`
const CardContentHeading = styled(Heading3)`
  font-size: 90%;
  @media ${props => props.theme.breakpoint.desktop} {
    font-size: 87.5% !important;
  }
`
const CardContent = ({ title, fluid, fallbackFluid, body }) => {
  return (
    <CardContentWrapper itemType="http://schema.org/Thing" itemScope>
      <CardImage itemProp="image" fluid={fluid} fallbackFluid={fallbackFluid} />
      <Content>
        <CardContentHeading itemProp="name">{title}</CardContentHeading>
        {body && (
          <CardContentDescription itemProp="description" data={body.json} />
        )}
      </Content>
    </CardContentWrapper>
  )
}

CardContent.propTypes = propTypes

CardContent.defaultProps = defaultProps

export default CardContent
